import { render, staticRenderFns } from "./NavLinkItem.vue?vue&type=template&id=4f472a46&scoped=true"
import script from "./NavLinkItem.vue?vue&type=script&lang=js"
export * from "./NavLinkItem.vue?vue&type=script&lang=js"
import style0 from "./NavLinkItem.vue?vue&type=style&index=0&id=4f472a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f472a46",
  null
  
)

export default component.exports